export const VISITOR_TYPE = Object.freeze({
    MEMBER: 'member',
    VISITOR: 'visitor'
});

export const TYPE = Object.freeze({
    WEB: 'web',
    PWA: 'pwa',
    IOS: 'ios',
    ANDROID: 'android'
});